import { EpubRendererType } from '../../../types/manageBooks';
import { useTranslation } from '../../../i18n/useTranslation';

interface Props {
  rendererType: EpubRendererType;
}

/**
 * Pill badge shown in the Renderer column of the admin books list.
 *
 * Presentational only. One pill per value:
 *   • CustomHtml — neutral grey (default for simple EPUBs, the bulk of the catalog)
 *   • EpubJs     — indigo (complex EPUBs: fixed-layout / scripts / media overlays)
 *   • Pdf        — amber (PDF books, rendered by UnifiedPdfRenderer, not either
 *                  EPUB renderer — distinct color signals "not the same category")
 */
export function RendererCell({ rendererType }: Props) {
  const { t } = useTranslation();

  if (rendererType === EpubRendererType.EpubJs) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-200">
        {t('App.Common.RendererType.EpubJs')}
      </span>
    );
  }
  if (rendererType === EpubRendererType.Pdf) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200">
        {t('App.Common.RendererType.Pdf')}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-neutral-100 text-neutral-700 border border-neutral-200">
      {t('App.Common.RendererType.CustomHtml')}
    </span>
  );
}
